import React, { useState } from 'react';
import { Modal } from '@carvana/showroom-modal';
import { RouterProvider } from '../providers/router';
import { ItemDetails } from './item-details';

type ConcernReportedModalProps = {
  onModalCloseCallback: () => void;
  reportedConcernData: any;
};

const ConcernReportedModal = ({
  reportedConcernData,
  onModalCloseCallback,
}: ConcernReportedModalProps) => {
  const [modalOpen, setModalOpen] = useState(true);

  return modalOpen ? (
    <Modal
      headerText="Concern Reported"
      isOpen={modalOpen}
      closeModal={() => {
        setModalOpen(false);
        onModalCloseCallback();
      }}
    >
      <RouterProvider>
        <ItemDetails concern={reportedConcernData} />
      </RouterProvider>
    </Modal>
  ) : null;
};

export default ConcernReportedModal;
